import { render, staticRenderFns } from "./DamSubstituicao.vue?vue&type=template&id=610f2243&scoped=true&"
import script from "./DamSubstituicao.vue?vue&type=script&lang=js&"
export * from "./DamSubstituicao.vue?vue&type=script&lang=js&"
import style0 from "./DamSubstituicao.vue?vue&type=style&index=0&id=610f2243&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610f2243",
  null
  
)

export default component.exports